import { render } from "./WhyChooseus.vue?vue&type=template&id=8f861bc0&scoped=true"
import script from "./WhyChooseus.vue?vue&type=script&lang=js"
export * from "./WhyChooseus.vue?vue&type=script&lang=js"

import "./WhyChooseus.vue?vue&type=style&index=0&id=8f861bc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f861bc0"]])

export default __exports__